<template>
<div class="content-head">
  <h1 class="heading-common">{{ lesson.lesson_number }}. <span class="font-jp">{{ lesson.title }} </span><span class="sub-menu-open" :class="{ 'open': isSubmenu }" @click="submenu"></span></h1>
  <div class="content-head-wrapper" @click.self="submenu" v-show="isSubmenu">
  <transition name="submenuslide" appear>
    <div class="sub-menu-modal" v-show="isSubmenu">
      <div class="sub-menu-grid">
        <template v-for="(movieQuizData, key) in movieQuizList">
        <div class="sub-menu-item" @click="movePage('movie', movieQuizData)" :class="movieQuizData.status_movie!='incomplete' ? 'active' : ''">
          <span class="menu-item-icon movie"></span>
          <span class="menu-item-title">{{ $t('lesson.moviequiz.title') }} {{ movieQuizData.number }}</span>
        </div>
        <div class="sub-menu-item" @click="movePage('quiz', movieQuizData)" :class="movieQuizData.status_quiz!='incomplete' ? 'active' : ''">
          <span class="menu-item-icon quiz"></span>
          <span class="menu-item-title">{{ $t('lesson.question.title') }} {{ movieQuizData.number }}</span>
        </div>
        </template>
        
        <div class="sub-menu-item" @click="movePage('review', reviewData)" :class="reviewData.status_review!='incomplete' ? 'active' : ''">
          <span class="menu-item-icon review"></span>
          <span class="menu-item-title">{{ $t('lesson.review.title') }}</span>
        </div>
        <div class="sub-menu-item" @click="movePage('exam', examData)" :class="examData.status_exam!='incomplete' ? 'active' : ''">
          <span class="menu-item-icon exam"></span>
          <span class="menu-item-title">{{ $t('lesson.exam.title') }}</span>
        </div>
      </div>
      <div class="sub-menu-row">
        <div class="sub-menu-item full active" @click="movePage('title')">
          <span class="menu-item-icon title"></span>
          <span class="menu-item-title">{{ $t('lesson.exam.button.to_title') }}</span>
        </div>
      </div>
      <div class="sub-menu-row">
          <div class="sub-menu-close" @click="submenu"></div>
      </div>
    </div>
  </transition>
  </div>
</div>
</template>

<script>
  import {appName, api} from "../../config";
  import {mapState} from 'vuex';
  import {mapGetters} from 'vuex';
  export default {
    name: "ContentHead",
    props: {
      section: {
        type: Object,
        required: true
      },
      lesson: {
        type: Object,
        required: true
      },
      contentsData: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        isSubmenu: false,
        lesson_content: {},
        moviequiz_list: [],
        review_data: {},
        exam_data: {}
      }
    },
    created() {
      
      this.lesson_content = this.$store.getters.lesson_content
      if(this.lesson_content.moviequiz.content !== undefined) {
        this.initData()
      }
    },

    computed: {
      lessonContent() {
         return this.lesson_content
      },
      movieQuizList() {
         return this.moviequiz_list
      },
      reviewData() {
         return this.review_data
      },
      examData() {
         return this.exam_data
      },
    },
    methods: {
      submenu() {
        if(this.isSubmenu) {
          this.isSubmenu = false
        } else {
          this.isSubmenu = true
          
          if(this.contentsData && Object.keys(this.contentsData).length) {
            this.updateData(this.contentsData)
          }
          
        }
      },
      
      initData() {
        this.moviequiz_list = []
        this.review_data = {}
        this.exam_data = {}
        
        let counter = Object.keys(this.lesson_content.moviequiz.content)
        for(let key of counter) {
          this.moviequiz_list.push({ number: key, title: this.lesson_content.moviequiz.content[key].title, status_quiz: this.lesson_content.moviequiz.content[key].status_quiz , status_movie: this.lesson_content.moviequiz.content[key].status_movie})
        }
        
        let reviewKey = Object.keys(this.lesson_content.review.content)
        this.review_data = this.lesson_content.review.content[reviewKey]
        let examKey = Object.keys(this.lesson_content.exam.content)
        this.exam_data = this.lesson_content.exam.content[examKey]
        
      },
      
      updateData(data) {
        this.moviequiz_list = []
        this.review_data = {}
        this.exam_data = {}
        
        let counter = Object.keys(data.moviequiz.content)
        for(let key of counter) {
          this.moviequiz_list.push({ number: key, title: data.moviequiz.content[key].title, status_quiz: data.moviequiz.content[key].status_quiz , status_movie: data.moviequiz.content[key].status_movie})
        }
        
        let reviewKey = Object.keys(data.review.content)
        this.review_data = data.review.content[reviewKey]
        let examKey = Object.keys(data.exam.content)
        this.exam_data = data.exam.content[examKey]
        
      },
      
      movePage(target, param) {
        const currentHistory = this.$router.history.current
        
        if(target == 'title') {
          this.isSubmenu = false
          this.$router.push({ name: 'lesson.category', params: { category: this.$store.getters.section_data.section } });
        } else if(target == 'movie') {
          
          if(param.status_movie == 'ready') return false;
          
          let pushVal = {name: 'lesson.movie', params: { lesson_id: this.lesson.lesson_id, content_order: param.number }}
          if(currentHistory) {
            if(currentHistory.name == pushVal.name && currentHistory.params.lesson_id == pushVal.params.lesson_id
                && currentHistory.params.content_order == pushVal.params.content_order) {
              return false
            }
          }
          
          this.isSubmenu = false
          this.$router.push(pushVal)
          
        } else if(target == 'quiz') {
          
          if(param.status_quiz == 'ready') return false;
          
          let pushVal = {name: 'lesson.quiz', params: { lesson_id: this.lesson.lesson_id, content_order: param.number }}
          if(currentHistory) {
            if(currentHistory.name == pushVal.name && currentHistory.params.lesson_id == pushVal.params.lesson_id
                && currentHistory.params.content_order == pushVal.params.content_order) {
              return false
            }
          }
          
          this.isSubmenu = false
          this.$router.push(pushVal)
        } else if(target == 'review') {
          
          if(param.status_review == 'ready') return false;
          
          let pushVal = { name: 'lesson.review', params: { lesson_id: this.lesson.lesson_id }}
          if(currentHistory) {
            if(currentHistory.name == pushVal.name && currentHistory.params.lesson_id == pushVal.params.lesson_id) {
              return false
            }
          }
          
          this.isSubmenu = false
          this.$router.push(pushVal)
        } else if(target == 'exam') {
          
          if(param.status_exam == 'ready') return false;
          
          let pushVal = {name: 'lesson.exam', params: { lesson_id: this.lesson.lesson_id }}
          if(currentHistory) {
            if(currentHistory.name == pushVal.name && currentHistory.params.lesson_id == pushVal.params.lesson_id) {
              return false
            }
          }
          
          this.isSubmenu = false
          this.$router.push(pushVal)
        }
      }
    }
  }
</script>